import { toast } from "react-toastify";
import api from "../../config/URL";
import { IoIosSend } from "react-icons/io";
import { useState } from "react";

function SendAndPublishPaymentReceipt({ data, fetchReceiptData }) {
  const [loadIndicator, setLoadIndicator] = useState(false);

  const centerName = data?.center || "--";
  const centerLogo = `https://smsbucket-for-sms.s3.ap-southeast-1.amazonaws.com/qr_code/ECS+QA/Logo-Portal_Access.png`;

  const sendEmail = async () => {
    const htmlContent = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Official Receipt</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          color: #000;
          padding: 10px;
          margin: 0;
        }

        .table-container {
          overflow-x: auto;
          margin-top: 20px;
        }

        .table-container table {
          min-width: 600px;
        }

        .receipt-box {
          max-width: 800px;
          margin: auto;
          border: 1px solid #ccc;
          padding: 20px;
          box-sizing: border-box;
          background: #fff;
        }

        .logo {
          width: 120px;
          margin-bottom: 10px;
        }

        .title {
          text-align: center;
          font-size: 20px;
          font-weight: bold;
          margin: 20px 0;
        }

        .details {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-bottom: 20px;
        }

        .column {
          width: 48%;
        }

        .receipt-line {
          display: flex;
          gap: 10px;
          margin-bottom: 8px;
          font-size: 14px;
          word-break: break-word;
        }

        .receipt-line .label {
          font-weight: bold;
          min-width: 150px;
        }

        .receipt-line .value {
          flex: 1;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
          font-size: 13px;
          word-break: break-word;
        }

        th, td {
          border: 1px solid #ccc;
          padding: 8px;
          text-align: left;
        }

        th {
          background-color: #f2f2f2;
        }

        .footer {
          margin-top: 30px;
          font-size: 12px;
          text-align: center;
          font-style: italic;
        }

        @media only screen and (max-width: 600px) {
          .column {
            width: 100%;
          }

          .receipt-line {
            flex-direction: column;
          }

          .receipt-line .label {
            min-width: auto;
            margin-bottom: 2px;
          }

          table, th, td {
            font-size: 11px;
          }
        }
      </style>
    </head>
    <body>
      <div class="receipt-box">
        <div class="title">Official Receipt</div>
        <div class="details">
          <div class="column">
            <div class="receipt-line">
              <span class="label">Received From</span>
              <span class="value"> : ${data.receivedFrom || "--"}</span>
            </div>
            <div class="receipt-line">
              <span class="label">Amount</span>
              <span class="value"> : ${data.currency || "SGD"} ${data.amount || "0.00"}</span>
            </div>
            <div class="receipt-line">
              <span class="label">Payment Method</span>
              <span class="value"> : ${data.paymentMethod || "--"}</span>
            </div>
            <div class="receipt-line">
              <span class="label">Receipt No.</span>
              <span class="value"> : ${data.receiptNo || "--"}</span>
            </div>
            <div class="receipt-line">
              <span class="label">Date</span>
              <span class="value"> : ${data.date || "--"}</span>
            </div>
            <div class="receipt-line">
              <span class="label">Being Payment Of</span>
              <span class="value"> : ${data.beingPaymentOf || "--"}</span>
            </div>
            
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th>Posting Date</th>
              <th>Document Type</th>
              <th>Document No.</th>
              <th>Description</th>
              <th>Original Amount</th>
              <th>Allocation Amount</th>
            </tr>
          </thead>
          <tbody>
            ${
              data.paymentSpecifications?.length
                ? data.paymentSpecifications
                    .map(
                      (item) => `
                <tr>
                  <td>${new Date(item.postingDate).toLocaleDateString(
                    "en-GB"
                  )}</td>
                  <td>${item.documentType}</td>
                  <td>${item.documentNo}</td>
                  <td>${item.description}</td>
                  <td>${data.currency} ${item.originalAmount}</td>
                  <td>${data.currency} ${item.allocationAmount}</td>
                </tr>`
                    )
                    .join("")
                : `<tr><td colspan="6" style="text-align:center;">No records found</td></tr>`
            }
          </tbody>
        </table>
      </div>
    </body>
    </html>
    `;

    try {
      const formData = new FormData();
      formData.append("from", data.email);
      formData.append("to", data.email);
      formData.append("subject", "Official Receipt");
      formData.append("htmlContent", htmlContent);

      setLoadIndicator(true);

      const res = await api.post("/sendMailWithAttachment", formData);
      if (res.status === 201) {
        toast.success("Receipt sent successfully");
        fetchReceiptData?.(); // optional refresh
      } else {
        toast.error("Failed to send receipt email");
      }
    } catch (error) {
      console.error("Email send error:", error);
      toast.error("Error sending receipt");
    } finally {
      setLoadIndicator(false);
    }
  };

  return (
    <button className="btn btn-border btn-sm me-1" onClick={sendEmail}>
      {loadIndicator && (
        <span
          class="spinner-border spinner-border-sm me-2"
          aria-hidden="true"
        ></span>
      )}
      <IoIosSend class="text-primary mb-1 me-1" />
      Send and Publish
    </button>
  );
}

export default SendAndPublishPaymentReceipt;
